module.exports = {"id":"200752","name":"Juan Jesus","rating":"77","photo":"./data/images/photos/3/200752.png","club":{"name":"AS Rome","logo":"./data/images/clubs/ASRome.png"},"positions":["DC","DG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JuanJesus0.json
// module id = 2215
// module chunks = 0